export const dataTableControlClassName =
  'h-8 rounded-lg border-dashboard-border bg-white px-3 text-xs font-medium text-neutral-700 shadow-sm shadow-neutral-900/5 transition-smooth hover:border-border-hover hover:bg-neutral-50 hover:text-neutral-950 focus-visible:ring-2 focus-visible:ring-primary/20 dark:border-dashboard-border dark:bg-white dark:text-neutral-700 dark:hover:bg-neutral-50'

export const dataTableControlIconClassName = 'h-3.5 w-3.5 text-neutral-500'

export const dataTableControlBadgeClassName =
  'ml-1 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-primary/10 px-1 text-[10px] font-semibold text-primary'
